import { z } from 'zod';
import { get, post } from '../http';
import { type ListQuery, paginated, resource } from '../schemas/common';
import { activationSchema, packageSchema } from '../schemas/domain';

export const activateInput = z.object({
  package_id: z.string().min(1, 'Choose a package'),
  /** Blank = activate yourself. Otherwise must be a downline member's User ID. */
  target_user_code: z.string().optional(),
  transaction_pin: z.string().min(4, 'Transaction PIN required'),
});
export type ActivateInput = z.infer<typeof activateInput>;

const activationPreview = z.object({
  package: packageSchema,
  activation_balance: z.string(),
  required_lds: z.string().nullable(),
  lds_rate_usd: z.string().nullable(),
  can_activate: z.boolean(),
  reason: z.string().nullable(),
});

export const activationsApi = {
  /** Quote + eligibility for the $100 joining package, for yourself or a downline member. */
  preview: (packageId: string, targetUserCode?: string) =>
    get('/activation/preview', resource(activationPreview), {
      package_id: packageId,
      ...(targetUserCode ? { target_user_code: targetUserCode } : {}),
    }),

  activate: (input: ActivateInput) => post('/activation', resource(activationSchema), input),

  history: (query: ListQuery = {}) => get('/activation/history', paginated(activationSchema), query),

  /* admin */
  adminList: (query: ListQuery = {}) => get('/admin/activations', paginated(activationSchema), query),
  adminActivate: (userId: string, packageId: string) =>
    post('/admin/activations', resource(activationSchema), {
      user_id: userId,
      package_id: packageId,
    }),
};
